/**
 * エリアドロップダウンのリストをセッションストレージから取得
 */
export function getAreaSession() {
    const res = sessionStorage.getItem('AREA_LIST')
    if (res) {
        return JSON.parse(res)
    }
    return null
}

/**
 * エリアドロップダウンのリストをセッションストレージに保存
 */
export function saveAreaSession(data) {
    if (data && data.length) {
        sessionStorage.setItem('AREA_LIST', JSON.stringify(data))
    }
}